module.exports = "<!-- Copyright The Linux Foundation and each contributor to LFX. -->\n<!-- SPDX-License-Identifier: MIT -->\n<div class=\"border-bottom border-gray d-flex align-items-center justify-content-center mt-3 pb-3 mb-0 h5\" i18n>\n    <img src=\"assets/_ionicons_svg_md-apps-black.svg\" class=\"ionicon-md mr-3\">\n    Policies\n</div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/access-management/policies/policies.component.html
// module id = ./src/app/access-management/policies/policies.component.html
// module chunks = access-management.module